import { axios } from "@/lib/axios";

export const getProjects = () => {
  return axios.get('/api/v1/projects/withProjectCategories')
}

export const getAdminCategories = () => {
  return axios.get('/api/v1/projects/withAdminCategories')
}